export default {
  DASHBOARD: "/dashboard",
  BOARD_NOW: "/board/now",
  STYLE_GUIDE: "/styleguide",
  CLIENT_MANAGEMENT: "/clientmanagement",
  CLIENT_CREATE: "/client/create",
  CLIENT_DETAIL: "/client/detail/",
  CLIENT_UPDATE: "/client/update/",
  STATE_CITY: "/state",
  CITY: "/city/",
  PROGRAM: "/program",
  PROGRAM_CREATE: "/program/create",
  PROGRAM_UPDATE: "/program/update/",
  PATIENT_DETAIL: "/patient/detail/",
  POPULAR_CITIES: "/popularcities",
  PET_MASTER: "/pet",
  PET_CREATE: "/pet/create",
  PET_UPDATE: "/pet/update/",
  APP_USERS: "/appusers",
  APP_DETAIL: "/appusers/detail/",
  QUIZ: "/quiz",
  QUIZ_CREATE: "/quiz/create",
  QUIZ_UPDATE: "/quiz/update/",
  QUIZ_DETAIL: "/quiz/detail/",
  HEALTH_TIPS: "/healthtips",
  HEALTH_CREATE: "/healthtips/create",
  HEALTH_UPDATE: "/healthtips/update/",
  HEALTH_DETAIL: "/healthtips/detail/",
  APP_SETTINGS: "/appsettings",
  DOCTOR_MASTER: "/doctor",
  REWARD: "/reward",
  REWARD_CREATE: "/reward/create",
  REWARD_UPDATE: "/reward/update/",
  REWARD_DETAIL: "/reward/detail/",
  GIFT: "/giftStore",
  GIFT_CREATE: "/giftStore/create",
  GIFT_UPDATE: "/giftStore/update/",
  GIFT_DETAIL: "/giftStore/detail/",
  REPORTED: "/reportedSideEffects",
  REPORTED_DETAIL: "/reportedSideEffects/detail",
  AUDIT_CREATE: "/auditTrialLog/create",
  ADMIN: "/client/user",
  ADMIN_CREATE: "/client/user/create",
  ADMIN_UPDATE: "/client/user/update/",
  ADMIN_DETAIL: "/client/user/detail/",
  ROLES: "/roles",
  ROLE_CREATE: "/role/create",
  ROLE_UPDATE: "/role/update/",
  ROLE_DETAIL: "/role/detail/",
  USER_QUERIES: "/user/queries",
  USER_QUERIES_DETAIL: "/user/queries/detail/",

  USER_ENGAGEMENT_DASHBOARD: "/user/engagement/dashboard",
  PROGRAM_DASHBOARD: "/program/dashboard",
  DOCTOR_DASHBOARD: "/",

  USER_AGGREEMENT: "/user/agreement",
  DIET: "/diet",
  DIET_CREATE: "/diet/create",
  DIET_UPDATE: "/diet/update/",
  DIET_DETAIL: "/diet/detail/",

  SHIFTS: "/shifts",
  SHIFTS_DETAILS: "/shifts/detail/",
  APPOINTMENT: "/",
  PATIENT_DETAIL: "/patient/detail/",
  VITALS_INFO: "/vitals/info/",


  DIETITIAN_PATIENT_DETAIL: "/dietitian/patient-detail/",

  DIETITIANS_DASHBOARD: "/dietitian/dashboard",

};
